import React from 'react';

const Main = ({ children }) => {
  return <main id="main">{children}</main>;
};

export default Main;
